import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a75067e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a75067e')) {
      api.createRecord('3a75067e', component.options)
    } else {
      api.reload('3a75067e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a75067e&", function () {
      api.rerender('3a75067e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/lostAndFound/goodsType/index.vue"
export default component.exports